<template>
  <div
    class="w-full bg-zt-white rounded-zt-md p-6"
    :class="[boxLogin.styles.shadow]"
    :style="[boxLogin.styles.box]"
  >
    <div class="flex flex-col items-center">
      <div
        class="mb-8 mt-3 flex justify-center h-full"
        :class="[boxLogin.sizeLogo === 'full' ? 'w-full' : 'w-56']"
      >
        <img class="format-img" :src="boxLogin.logoUrl" alt="" />
      </div>
      <div class="flex flex-col items-center w-full">
        <graphic-base width="100" height="100" view-box="0 0 126 126">
          <circle-lock />
        </graphic-base>
        <div
          class="text-center w-4/5 lg:w-3/5 mt-10 text-zt-primary-200"
          :style="[boxLogin.styles.form.textColor]"
        >
          <h1 class="text-zt-lg mb-4 font-bold">
            {{ $t('message.loginComponent.blockedUser.title') }}
          </h1>
          <div
            class="text-zt-dark-400"
            :style="[boxLogin.styles.form.textColor]"
          >
            <p class="mb-4">
              {{ $t('message.loginComponent.blockedUser.msg_1') }}
            </p>
            <p>{{ $t('message.loginComponent.blockedUser.msg_3') }}</p>
          </div>
        </div>
      </div>
      <div class="mt-4 w-full">
        <div class="mb-4">
          <zt-button
            class="w-full opacity-100"
            :style="[boxLogin.styles.form.buttons.bgColor]"
            @click="gotoLogin"
            data-vs-button="auth-login-block-btn-gotologin"
          >
            {{ $t('message.loginComponent.forgetPassword.goBack') }}
          </zt-button>
        </div>
      </div>
      <div class="mb-6">
        <span :style="[boxLogin.styles.form.textColor]">{{
          $t('message.loginComponent.blockedUser.mailResendMsg')
        }}</span>
        <a @click="resendMail" class="text-zt-secondary-200 ml-1" data-vs-link="auth-login-block-link-resendmail">{{
          $t('message.loginComponent.blockedUser.mailResend')
        }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import CircleLock from '@/components/commons/Illustrations/graphicSVG/circleLock'
import GraphicBase from '@/components/commons/Illustrations/graphicBase'
import loginCustomParams from '@/modules/Auth/mixins/loginCustomParams'
import { mapGetters } from 'vuex'
import Auth from '@/apiClient/Auth'

export default {
  name: 'ztAuthLoginUserBlock',
  components: { GraphicBase, CircleLock },
  inject: ['storeUser'],
  mixins: [loginCustomParams],
  data() {
    return {
      objectLoginParams: {}
    }
  },
  computed: {
    ...mapGetters({
      getLoginCustomParams: 'auth/getLoginCustomParams'
    })
  },
  methods: {
    gotoLogin() {
      this.$store.dispatch('clearState')
      this.$router.push({ name: 'login' })
    },
    async resendMail() {
      try {
        await this.$recaptchaLoaded()
        await this.$recaptcha('login')
        await this.auth
          .login(
            this.storeUser.userBlock.u.trim().toLowerCase(),
            this.storeUser.userBlock.p
          )
          .catch(error => {
            console.error('Error', error)
          })
      } catch (e) {
        console.error('Error ', e)
      }
    }
  },
  created() {
    this.auth = new Auth()
    this.objectLoginParams = this.getLoginCustomParams.loginCustom
  }
}
</script>

<style scoped lang="scss">
.format-img {
  height: 100%;
  max-width: 100%;
  vertical-align: middle;
  width: 100%;
  -ms-interpolation-mode: bicubic;
  display: inline-block;
}
::v-deep .zt-button {
  height: 3.25rem;
}
</style>
